<template>
  <div
    class="flex flex-col"
    :class="{ 'items-center': question.isSmileyImage }"
  >
    <div
      v-if="question.image"
      class="flex justify-center items-end overflow-hidden"
      :class="{
        'rounded-lg mb-[-8px]': !question.isSmileyImage,
      }"
    >
      <RevIllustration
        alt=""
        class="object-cover"
        :class="{
          'h-[150px] w-[150px]': question.isSmileyImage,
          'h-[395px] w-full md:w-[480px] md:h-[372px]': !question.isSmileyImage,
        }"
        :height="480"
        :src="question.image"
        :width="480"
      />
    </div>
    <div
      class="flex py-24 flex-col items-center relative w-full"
      :class="{ 'gap-6 text-center': question.isSmileyImage }"
    >
      <h3
        v-if="question.title"
        :class="{
          'text-center heading-2': question.image,
          'heading-3': !question.image,
        }"
      >
        {{ question.title }}
      </h3>
      <QuestionsFormItemText
        v-if="question.showInfo"
        :centered="!!question.image"
        class="my-16"
        :class="{ 'self-start': !question.image }"
        :info="question.info"
      />
      <div class="flex flex-col w-full gap-8">
        <RevButton
          v-if="question.options[0]"
          :data-qa="question.key"
          fullWidth="always"
          variant="primary"
          @click="
            emit('answer', question.key, question.options[0].value as string)
          "
        >
          {{ question.options[0].label }}
        </RevButton>
        <button
          v-if="question.options[1]"
          class="body-1-bold mt-8 w-full cursor-pointer underline"
          type="button"
          @click="
            emit('answer', question.key, question.options[1].value as string)
          "
        >
          {{ question.options[1].label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import type { RenderQuestion } from '~/scopes/buyback/composables/useFunnelQuestions'

import QuestionsFormItemText from './QuestionsFormItemText.vue'

defineProps<{
  question: RenderQuestion
}>()

const emit = defineEmits<{
  (event: 'answer', key: string, value: string): void
}>()
</script>
